import React from "react";
import { motion } from "framer-motion";
import { Mail, Linkedin, MapPin, Youtube, Github } from "lucide-react";
import { PROFILE, PHOTOS } from "../../data/content";

export default function ProAbout() {
  return (
    <div className="pt-24 pb-16" data-testid="pro-about">
      <section className="max-w-6xl mx-auto px-5 md:px-8">
        <p className="font-plexMono text-xs uppercase tracking-[0.2em] text-terracotta">About</p>
        <h1 className="font-serif font-light text-4xl md:text-6xl text-neutral-900 mt-3">
          Hi, I&apos;m Arya.
        </h1>

        <div className="mt-14 grid md:grid-cols-12 gap-10 md:gap-14">
          <div className="md:col-span-4 order-2 md:order-1">
            <div className="rounded-2xl overflow-hidden bg-neutral-100 aspect-[3/4]">
              <img
                src={PHOTOS.portrait}
                alt="Arya Kadulkar"
                loading="lazy"
                className="w-full h-full object-cover object-[center_18%]"
              />
            </div>
            <div className="mt-6 space-y-3 font-plex text-sm">
              <p className="text-neutral-500 uppercase tracking-widest text-xs font-plexMono">
                Fast facts
              </p>
              <p className="flex items-center gap-2 text-neutral-700">
                <MapPin size={14} className="text-neutral-400" /> {PROFILE.location}
              </p>
              <p className="flex items-center gap-2 text-neutral-700">
                <Mail size={14} className="text-neutral-400" />
                <a href={`mailto:${PROFILE.email}`} className="hover:text-terracotta">
                  {PROFILE.email}
                </a>
              </p>
              <p className="flex items-center gap-2 text-neutral-700">
                <Linkedin size={14} className="text-neutral-400" />
                <a
                  href={PROFILE.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-terracotta"
                >
                  Arya Kadulkar
                </a>
              </p>
              <p className="flex items-center gap-2 text-neutral-700">
                <Youtube size={14} className="text-neutral-400" />
                <a
                  href="https://www.youtube.com/@aryakadulkar6774"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-terracotta"
                  data-testid="pro-about-youtube"
                >
                  @aryakadulkar6774
                </a>
              </p>
              <p className="flex items-center gap-2 text-neutral-700">
                <Github size={14} className="text-neutral-400" />
                <a
                  href="https://github.com/aryakadulkar"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-terracotta"
                  data-testid="pro-about-github"
                >
                  @aryakadulkar
                </a>
              </p>
            </div>
          </div>

          <div className="md:col-span-8 order-1 md:order-2 space-y-6">
            <p className="font-serif italic text-2xl md:text-3xl text-neutral-800 leading-snug">
              Business Central technical consultant. Three years in, still learning, getting it
              done every week.
            </p>

            <motion.div
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="space-y-5 font-plex text-neutral-700 leading-relaxed text-lg"
            >
              <p>
                I work end-to-end on Microsoft Dynamics 365 Business Central — from messy problem
                statements through to polished go-lives. My day-to-day covers Sales, Purchase,
                Warehouse, Production, Project and Gate Entry modules, plus custom Purchase
                Requisition and Quality Control flows tailored to each client.
              </p>
              <p>
                I care deeply about clean AL code, considered integrations (Azure, banking,
                accounting, CRM), Navision-to-BC upgrades that don&apos;t break anything, and reports that
                group information exactly the way finance and manufacturing teams actually need.
              </p>
              <p>
                Outside of work you&apos;ll find me creating content, painting, or sipping coffee on
                a mountain somewhere. Recently moved to Bangalore.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
